import { SVGProps } from "react";

const NoAddress = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={63}
    height={63}
    viewBox="0 0 63 63"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.01123 20.4226V45.9638C6.01123 50.9513 9.55498 52.9988 13.86 50.5313L20.0287 47.0138C21.3675 46.2526 23.5987 46.1738 24.99 46.8826L38.7712 53.7863C40.1625 54.4688 42.3937 54.4163 43.7325 53.6551L55.0987 47.1451C56.5425 46.3051 57.75 44.2576 57.75 42.5776V17.0363C57.75 12.0488 54.2062 10.0013 49.9012 12.4688L43.7325 15.9863C42.3937 16.7476 40.1625 16.8263 38.7712 16.1176L24.99 9.24006C23.5987 8.55756 21.3675 8.61006 20.0287 9.37131L8.66248 15.8813C7.19248 16.7213 6.01123 18.7688 6.01123 20.4226Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M22.4702 10.5V44.625"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M41.291 17.3774V52.4999"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default NoAddress;
